export type JackpotSlug =
  | 'OpenQual-A'
  | 'OpenQual-B'
  | 'OpenQual-C'
  | 'ClosedQual-A1'
  | 'ClosedQual-A2'
  | 'ClosedQual-A3'
  | 'ClosedQual-B1'
  | 'ClosedQual-B2'
  | 'ClosedQual-B3'
  | 'ClosedQual-C1'
  | 'ClosedQual-C2'
  | 'ClosedQual-C3'
  | 'Final1'
  | 'ActivePlayers'
  | 'Partner'
  | 'Platinum';

export const jackpotsOrder: JackpotSlug[] = [
  'OpenQual-A',
  'ClosedQual-A1',
  'ClosedQual-A2',
  'ClosedQual-A3',
  'OpenQual-B',
  'ClosedQual-B1',
  'ClosedQual-B2',
  'ClosedQual-B3',
  'OpenQual-C',
  'ClosedQual-C1',
  'ClosedQual-C2',
  'ClosedQual-C3',
  'Final1',
  'ActivePlayers',
  'Partner',
  'Platinum',
];

// для Prize Fund джекпотов в Leagues и My
export const jackpotsJettons: JackpotsJettons = {
  'OpenQual-A': ['OpenQual-A', 'ClosedQual-A1', 'ClosedQual-A2', 'ClosedQual-A3'],
  'ClosedQual-A1': ['ClosedQual-A1', 'Final1'],
  'ClosedQual-A2': ['ClosedQual-A2', 'Final1'],
  'ClosedQual-A3': ['ClosedQual-A3', 'Final1'],
  'OpenQual-B': ['OpenQual-B', 'ClosedQual-B1', 'ClosedQual-B2', 'ClosedQual-B3'],
  'ClosedQual-B1': ['ClosedQual-B1', 'Final1'],
  'ClosedQual-B2': ['ClosedQual-B2', 'Final1'],
  'ClosedQual-B3': ['ClosedQual-B3', 'Final1'],
  'OpenQual-C': ['OpenQual-C', 'ClosedQual-C1', 'ClosedQual-C2', 'ClosedQual-C3'],
  'ClosedQual-C1': ['ClosedQual-C1', 'Final1'],
  'ClosedQual-C2': ['ClosedQual-C2', 'Final1'],
  'ClosedQual-C3': ['ClosedQual-C3', 'Final1'],
  Final1: ['Final1'],
  ActivePlayers: ['ActivePlayers'],
  Partner: ['Partner'],
  Platinum: ['Platinum'],
};

export type JackpotsJettons = Record<JackpotSlug, JackpotSlug[]>;
